"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomeAssignment = exports.DSTP001_Regist = exports.DSTL001_Detail = exports.DSTL001_List = void 0;
var DSTL001_List_1 = require("./DSTL001_List");
Object.defineProperty(exports, "DSTL001_List", { enumerable: true, get: function () { return DSTL001_List_1.DSTL001_List; } });
var DSTL001_Detail_1 = require("./DSTL001_Detail");
Object.defineProperty(exports, "DSTL001_Detail", { enumerable: true, get: function () { return DSTL001_Detail_1.DSTL001_Detail; } });
var DSTP001_Regist_1 = require("./DSTP001_Regist");
Object.defineProperty(exports, "DSTP001_Regist", { enumerable: true, get: function () { return DSTP001_Regist_1.DSTP001_Regist; } });
var HomeAssignment_1 = require("./HomeAssignment");
Object.defineProperty(exports, "HomeAssignment", { enumerable: true, get: function () { return HomeAssignment_1.HomeAssignment; } });
